import moment from 'moment';
import 'moment-timezone';
import pick from 'lodash/pick';
import { getSearchParameter } from '../../../utils/urlFunctions';
import { parseJSON } from '../../../utils/string';
import { getArray } from '../../../utils/typeUtils';

const KITCHEN_PLAYER_PREFIX = '/kitchen-player';

export const switchKitchenPlayerTab = (tab, history) => {
  if (history.location.pathname.includes(`${KITCHEN_PLAYER_PREFIX}/${tab}`)) return;

  const transferableParams = ['restaurantUuid'];

  const searchParams = transferableParams.reduce((acc, param) => {
    const paramValue = getSearchParameter(param);

    if (paramValue) {
      const divider = acc !== '' ? '&' : '?';
      let fullSearchParam = `${param}=${paramValue}`;

      return acc + divider + fullSearchParam;
    }

    return acc;
  }, '');

  history.push(`${KITCHEN_PLAYER_PREFIX}/${tab}` + searchParams);
};

export const prepareActivityData = (events, timezone) => {
  let lastHour = null;
  let midpointAdded = false;
  let lastIndexInHour = null;

  const updatedEvents = events.map((event, index) => {
    const currentHour = moment(event.eventTime).hours();
    const currentMinutes = moment(event.eventTime).minutes();
    const eventTs = moment.tz(event.eventTime, timezone || 'UTC').valueOf();

    let displayTime = false;

    if (currentHour !== lastHour) {
      displayTime = true;
      lastHour = currentHour;
      midpointAdded = false;
    }

    if (!midpointAdded && currentMinutes >= 25 && currentMinutes <= 35) {
      displayTime = true;
      midpointAdded = true;
    }

    lastIndexInHour = index;
    return { ...event, displayTime, currentHour, eventTs };
  });

  return updatedEvents.map((event, index) => {
    const isLastInHour =
      updatedEvents.findIndex((e, i) => e.currentHour === event.currentHour && i > index) === -1;
    if (isLastInHour) {
      return { ...event, displayTime: true };
    }
    return event;
  });
};

export function makeLocalStorageKitchenPlayer(player) {
  return {
    mute: false,
    ...player,
  };
}

export function getLocalStoragePlayers(restUuid) {
  const kitchenPlayersJSON = localStorage.getItem('kitchenPlayers');
  const kitchenPlayers = parseJSON(kitchenPlayersJSON);

  return getArray(kitchenPlayers?.[restUuid]);
}

export function setLocalStoragePlayers(restUuid, players) {
  const kitchenPlayersJSON = localStorage.getItem('kitchenPlayers');
  let kitchenPlayers = parseJSON(kitchenPlayersJSON);

  if (!kitchenPlayers) {
    kitchenPlayers = {};
  }

  const currentPlayers = kitchenPlayers[restUuid] || [];
  const playersMap = new Map(currentPlayers.map(player => [player.activeStreamId, { ...player, active: false }]));

  players.forEach(player => {
    playersMap.set(player.activeStreamId, {
      ...playersMap.get(player.activeStreamId),
      ...pick(player, ['activeStreamId', 'mute']),
      active: true,
    });
  });

  kitchenPlayers[restUuid] = [
    ...players.map(player => playersMap.get(player.activeStreamId)),
    ...Array.from(playersMap.values()).filter(player => !player.active),
  ];

  localStorage.setItem('kitchenPlayers', JSON.stringify(kitchenPlayers));
}

export function setLocalStoragePlayer(restUuid, player) {
  const kitchenPlayersJSON = localStorage.getItem('kitchenPlayers');
  let kitchenPlayers = parseJSON(kitchenPlayersJSON);

  if (!kitchenPlayers) {
    kitchenPlayers = {};
  }

  const players = kitchenPlayers[restUuid] || [];
  const index = players.findIndex(item => item.activeStreamId === player.activeStreamId);

  if (index !== -1) {
    players[index] = makeLocalStorageKitchenPlayer({
      ...players[index],
      ...player,
    });
  } else {
    players.push(makeLocalStorageKitchenPlayer(player));
  }

  kitchenPlayers[restUuid] = players;
  localStorage.setItem('kitchenPlayers', JSON.stringify(kitchenPlayers));
}

export function makeNotificationEventName(streamId) {
  return `streamNotification-${streamId}`;
}

export function makeBBoxEventName(streamId) {
  return `streamBBoxEvent-${streamId}`;
}
